export default __webpack_public_path__ + "static/media/ShoeNorm.33d28f0e.jpg";